angular.module('impactx.vcatalog').service('ShopViewService', ShopViewService);

ShopViewService.$inject = ['$rootScope', 'dataGen', '$context', '$q', 'searchFilter', '$redirect', 'ToastService', '$location',
    '$securityManager', 'TranslationService', 'WarningService'];

function ShopViewService($rootScope, dataGen, $context, $q, searchFilter, $redirect, ToastService, $location, $securityManager,
                         TranslationService, WarningService) {
    var pathWatcher;
    var sourcePath;
    var self = this;
    self.okTrns = TranslationService.get("ok");
    self.hintTrns = TranslationService.get("hint");

    function checkProductInShopView(productId, oldRoute) {
        dataGen.getData({}, {proId: productId}, "/vcatalog/checkproductinshopview").then(function (data) {
            if (!data.data.value) {
                deactivateShopViewInternal(oldRoute);
            }
        });
    }

    function activateShopView(params) {
        dataGen.postAsForm({}, {id: params.id}, "/vcatalog/activateshopview").then(function (data) {
            searchFilter.listSearch.value = true;
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
                searchFilter.listSearch.value = true;
                if (params.redirectPath) {
                    $redirect.redirectTo(null, params.redirectPath);
                }
                else {
                    $redirect.redirectTo(null, "/vcatalog/" + params.id);
                }
                sourcePath = params.sourcePath;
                if(data.trns.changedCatsHint) {
                    WarningService.showWarningDialog(null, null, self.hintTrns, null, self.okTrns, [data.trns.changedCatsHint], null, true);
                }
                ToastService.openStandardToast(data.trns.shopViewActivated);
            });
            if (pathWatcher) {
                pathWatcher();
            }
            pathWatcher = $rootScope.$watch(function () {
                return $location.path();
            }, function (newRoute, oldRoute) {
                if (newRoute !== oldRoute && newRoute.indexOf('vcatalog/') < 0 &&
                    newRoute.indexOf('search.product/vcat') < 0 && newRoute.indexOf('product/') < 0 &&
                    newRoute.indexOf('productredirect/') < 0) {
                    deactivateShopViewInternal(oldRoute);
                }
                else {
                    if (newRoute !== oldRoute && (newRoute.indexOf('/product/') === 0 || newRoute.indexOf('/productredirect/') === 0)) {
                        var secondIndex = newRoute.indexOf("/", newRoute.indexOf("/") + 1) + 1;
                        var thirdIndex = newRoute.indexOf("/", secondIndex);
                        checkProductInShopView(thirdIndex > 0 ? newRoute.substring(secondIndex, thirdIndex) :
                            newRoute.substring(secondIndex), oldRoute);
                    }
                }

            });
        });
    }

    function deactivateShopViewInternal(oldRoute) {
        var leftShopViewId = $context.hasActiveShopView.id;

        deactivateShopView(true).then(function () {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                searchFilter.resetSearchFilter();
            });
        });
        if ($securityManager.isAuthorized()) {
            ToastService.openActionToast(TranslationService.get('deactivatedShopView'), TranslationService.get('revert'),
                activateShopView, null, {id: leftShopViewId, redirectPath: oldRoute});
        }
    }

    function deactivateShopView(deactivateOnBackend) {
        if (pathWatcher) {
            pathWatcher();
        }
        if (deactivateOnBackend) {
            if ($context.hasActiveShopView && $context.hasActiveShopView.value) {
                return dataGen.postAsForm({}, {}, "/vcatalog/deactivateshopview");
            }
            else {
                return $q.when();
            }
        }
    }

    function getSourcePath() {
        return sourcePath;
    }

    return {
        deactivateShopView: deactivateShopView,
        activateShopView: activateShopView,
        getSourcePath: getSourcePath
    };
}